module.exports = __webpack_public_path__ + "static/img/04.44cddd2b.jpg";